import F from"./to-integer-or-infinity.js";var n=F,r=Math.min,i=function(t){return t>0?r(n(t),9007199254740991):0};export{i as default};
